import React from "react";
import {
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  InputLabel,
} from "@mui/material";

function GearType({ gearType, onChange }) {
  return (
    <FormControl
      variant="standard"
      sx={{
        maxWidth: window.innerWidth < 750 ? "75%" : "320px",
        minWidth: window.innerWidth < 750 ? "75%" : "230px",
      }}
    >
      <InputLabel id="gear_type_label">Gear Type</InputLabel>
      <Select
        labelId="gear_type_label"
        id="gear_type"
        name="gear_type"
        onChange={onChange("gearType")}
        value={gearType}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="TRAWL">TRAWL</MenuItem>
        <MenuItem value="HOOK">HOOK</MenuItem>
        <MenuItem value="GILL">GILL</MenuItem>
      </Select>
      <FormHelperText>Select the Gear Type to be used</FormHelperText>
    </FormControl>
  );
}

export default GearType;
